import { createSelector } from 'reselect'

const getState = state => state.PupilProfileStore

const getData = (state, selector) => {
  const data = state.PupilProfileStore ? state.PupilProfileStore : state
  return !data ? null : selector(data)
}

const getGroups = state => getState(state).groups

const getPupilFetchingStatus = (state, id) =>
  getData(
    state,
    data => data.fetching[id] || { pending: true, requestError: null }
  )

const getPupilUpdatingStatus = (state, id) =>
  getData(state, data => data.updating[id] || {})

const getPupilPasscodeResettingStatus = (state, id) =>
  getData(state, data => data.resettingPasscode[id] || {})

const getPupilRemovingFromGroupStatus = (state, id) =>
  getData(state, data => data.removingFromGroup[id] || {})

const getPupilAddingToGroupStatus = (state, id) =>
  getData(state, data => data.addingToGroup[id] || {})

const getProfile = state => getState(state).profile

const getPupilGroupIds = createSelector(
  [getGroups],
  groups => (!groups ? [] : groups.result)
)

const getGroupsMap = createSelector(
  [getGroups],
  groups => (!groups ? {} : groups.entities.groups)
)

const getPupilGroup = (state, groupId) => getGroupsMap(state)[groupId]

export {
  getState,
  getProfile,
  getPupilFetchingStatus,
  getPupilUpdatingStatus,
  getPupilPasscodeResettingStatus,
  getPupilRemovingFromGroupStatus,
  getPupilAddingToGroupStatus,
  getPupilGroup,
  getPupilGroupIds
}
